import { attribute } from 'dom-helpers';
import ownDoc from 'dom-helpers/ownerDocument';
import qsa from 'dom-helpers/querySelectorAll';
import React, { useCallback, useEffect } from 'react';
import classNames from 'classnames';
import { AppState } from 'core/redux/reducers';
import {
  actions as navActions,
  NavTypes,
} from 'core/redux/features/shared/nav';
import { useDispatch, useSelector } from 'react-redux';
import { selectViewTypeFilterOption } from '../../../core/redux/features/shared/reducers';
import DesktopNavMenu from './DesktopNavMenus';
import {
  selectActiveParentCity,
  selectActiveProductType,
  selectProductTypeFilterOption,
} from 'core/redux/features/products/reducers/productTypes';
import { useSelectNavIsHidden, useTrans } from 'core/hooks';
import { useHistory } from 'react-router';
import * as H from 'history';

export const NavBurger = (props: {
  isActive: boolean;
  onClick: (e: React.SyntheticEvent) => void;
  show?: boolean;
}) => {
  return (
    <a
      className={classNames(
        'navbar-burger burger is-left',
        props.isActive && 'is-active',
        props.show && 'is-show',
      )}
      onClick={props.onClick}
    >
      <span />
      <span />
      <span />
    </a>
  );
};

NavBurger.defaultPorps = {
  show: false,
};

const isPrevUrlSameAsHost = () => {
  console.log(document.referrer);

  // no referrer means false
  if (!document.referrer) {
    return false;
  }

  const ref = new URL(document.referrer);
  console.log(ref);
  return ref.hostname === window.location.hostname;
};

const __STORE_KEY = '__EB_LPV__'; // last page visit storage key
const lastPageVisit = {
  goBack: (history: H.History) => {
    const find = lastPageVisit.data();

    // if the last page is the same as the current page
    if (find === window.location.href) {
      window.location.href = '/';
      return;
    }

    if (!find.startsWith('http')) {
      window.location.href = '/';
      return;
    }

    const data = new URL(lastPageVisit.data());

    if (data.hostname !== window.location.hostname) {
      window.location.href = '/';
      return;
    }

    history.goBack();
  },
  data: () => {
    if (!window.localStorage) return '/';
    let lastHref = window.localStorage.getItem(__STORE_KEY);
    if (!lastHref) return '/';

    return lastHref;
  },
  record: () => {
    const lastHref = lastPageVisit.data();

    // don't record if the last page is the same as the current page
    if (lastHref === window.location.href) return;

    if (window.localStorage) {
      window.localStorage.setItem(__STORE_KEY, window.location.href);
    }
  },
  clear: () => {
    if (window.localStorage) {
      window.localStorage.setItem(__STORE_KEY, '');
    }
  },
};

export function useBeforeUnload(callback: () => any): void {
  useEffect(() => {
    window.addEventListener('beforeunload', callback);
    return () => {
      window.removeEventListener('beforeunload', callback);
    };
  }, [callback]);
}

function NavComponent({ showBack = false }: { showBack?: boolean }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const trans = useTrans();

  // products
  const activeProductType = useSelector(selectActiveProductType);
  const productTypesOptions = useSelector(selectProductTypeFilterOption);

  // areas
  const activeParentArea = useSelector(selectActiveParentCity);
  const parentAreas = useSelector((state: AppState) => state.parentAreas);

  const {
    local,
    menuActive,
    deviceType,
    viewTypes,
    activeViewType,
  } = useSelector((state: AppState) => ({
    menuActive: state.nav.active,
    deviceType: state.deviceType,
    local: state.local,
    viewTypes: selectViewTypeFilterOption(state),
    activeViewType: state.viewTypes.activeViewType,
  }));

  const isBackHidden = useSelectNavIsHidden('backbtn');
  const showBackForMobile = showBack && deviceType === 'mobile';

  function handleLanguageSwitch(e: React.SyntheticEvent, local: string) {
    let metaLocals = qsa(
      ownDoc(),
      'link[rel="alternate"][hreflang="' + local + '"]',
    );

    try {
      e.preventDefault();

      let href = '/';
      if (metaLocals.length > 0) {
        href = attribute(metaLocals[0], 'href');
        new URL(href);
      } else {
        let isGuide =
          window.location.pathname.startsWith('/guide/') ||
          window.location.pathname.startsWith('/en/guide/');

        if (isGuide) {
          href = '/guide';
        }

        if (isGuide && local !== 'da') {
          href = '/' + local + href;
        }
      }

      window.location.href = href;
    } catch (_) {}
  }

  const getActiveRoute = (): null | string => {
    if (viewTypes.length === 0) return null;

    let activeRoute = viewTypes[0].route;
    viewTypes.forEach(item => {
      if (item.id === activeViewType) {
        activeRoute = item.route;
      }
    });

    return activeRoute;
  };

  useBeforeUnload(
    useCallback(() => {
      lastPageVisit.record();
    }, []),
  );

  return (
    <nav className="navbar is-primary">
      <div className="container">
        <div className="navbar-brand center">
          <div
            className="navbar-back"
            onClick={e => {
              let activeRoute = getActiveRoute();
              if (!activeRoute) {
                // when referrer is empty got back to home
                // if (!isPrevUrlSameAsHost()) {
                //   history.goBack();
                //   // window.location.href = '/';
                //   return;
                // }

                lastPageVisit.goBack(history);

                // console.log(history);
                // history.goBack();

                return;
              }

              let isPartner =
                window.location.pathname.indexOf('partnere/') > -1 ||
                window.location.pathname.indexOf('partner/') > -1;

              if (isPartner) {
                window.location.href = activeRoute;
              } else {
                history.push(activeRoute);
              }
            }}
            style={{
              display: isBackHidden && !showBackForMobile ? 'none' : '',
            }}
          >
            <div className="eb-circle nav-circle">
              <span className="eb eb-pl" />
            </div>
          </div>

          <a href={`/${local}`} className="navbar-item navbar-item-logo">
            <span className="logo" />
          </a>
          <NavBurger
            onClick={_ => dispatch(navActions.toggle(NavTypes.Menu))}
            isActive={menuActive}
          />
        </div>
        <div id="default-nav" className="navbar-menu">
          <div className="navbar-end">
            {productTypesOptions.length > 1 && (
              <div className="navbar-item has-dropdown is-hoverable navbar-item--pill">
                <a href={activeProductType.route} className="navbar-link">
                  <span className="icon is-float-left">
                    <span className="eb-circle is-white font-blue">
                      <span className="eb eb-fork" />
                    </span>
                  </span>
                  <span className="is-uppercase">
                    {activeProductType.label}
                  </span>
                </a>
                <div className="navbar-dropdown">
                  {productTypesOptions.map((type, arrIndex) => {
                    return (
                      <a
                        key={arrIndex}
                        href={type.route}
                        className="navbar-item is-uppercase"
                      >
                        {type.label}
                      </a>
                    );
                  })}
                </div>
              </div>
            )}

            {productTypesOptions.length > 0 && (
              <div className="navbar-item has-dropdown is-hoverable navbar-item--pill">
                <a
                  href={trans(`routes.${activeProductType.id}_by_city`, {
                    city: activeParentArea?.slug ?? parentAreas?.[0]?.slug,
                  })}
                  className="navbar-link"
                >
                  <span className="icon is-float-left">
                    <span className="eb-circle is-white font-blue">
                      <span className="eb eb-map1" />
                    </span>
                  </span>
                  <span className="is-uppercase">
                    {activeParentArea?.label ?? parentAreas?.[0]?.label}
                  </span>
                </a>
                <div className="navbar-dropdown">
                  {parentAreas?.map((area, arrIndex) => {
                    return (
                      <a
                        key={arrIndex}
                        href={trans(`routes.${activeProductType.id}_by_city`, {
                          city: area.slug,
                        })}
                        className="navbar-item is-uppercase"
                      >
                        {area.label}
                      </a>
                    );
                  })}
                </div>
              </div>
            )}

            {deviceType === 'desktop' ? (
              <div className="navbar-item has-dropdown is-hoverable">
                <NavBurger show={true} onClick={_ => ''} isActive={false} />

                <div className="navbar-dropdown is-right">
                  <DesktopNavMenu />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </nav>
  );
}

// const Nav =
//   process.env.NODE_ENV !== 'production' ? hot(NavComponent) : NavComponent;

// const Nav = connect(mapStateToProps, mapDispatchToProps)(NavRoot)

export default NavComponent;
